import React from 'react'

import { Link } from 'gatsby'

import IconCard from '@components/Content/IconCard/IconCard'

import { SolutionsGridShowcaseCardType } from '@contracts/Homepage'

import * as styles from './HomepageSolutionsGrid.module.scss'

interface Props {
	cards: SolutionsGridShowcaseCardType[]
}

const HomepageSolutionsGrid = (props: Props) => {
	return (
		<ul className={styles.grid}>
			{props.cards.map(({ card }) => {
				return (
					<li key={card.text} className={styles.item}>
						<Link to={`${card.link.link}#mission`}>
							<IconCard data={card} className={styles.card} />
						</Link>
					</li>
				)
			})}
		</ul>
	)
}

export default HomepageSolutionsGrid
